module.exports = __webpack_public_path__ + "img/img2zhTc.a0184cee.png";